import Api from "../axios";

export default async function apiApproveLateComing(applicationId) {
  return await Api.post(`/approve_late_coming`, {
    application_id: applicationId,
  });
}
